import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, Mail, MessageCircle } from 'lucide-react';
import { Button } from '../components/ui/button';

const ContactUs = () => {
  const navigate = useNavigate();

  const handleEmailClick = () => {
    window.location.href = 'mailto:Admin@smartreadgo.com?subject=SmartReadGo Support Request';
  };

  const handleWhatsAppClick = () => {
    window.location.href = 'https://wa.me/919004685736?text=Hello%20SmartReadGo%20Support';
  };

  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <header className="bg-white border-b border-gray-200 sticky top-0 z-50">
        <div className="px-4 py-4 flex items-center gap-3">
          <button
            onClick={() => navigate('/settings')}
            className="p-2 hover:bg-gray-100 rounded-full transition-colors"
          >
            <ArrowLeft className="w-6 h-6 text-gray-700" />
          </button>
          <div>
            <h1 className="text-xl font-bold text-gray-900">Contact Us</h1>
            <p className="text-sm text-gray-600">Get help and support</p>
          </div>
        </div>
      </header>

      {/* Content */}
      <div className="px-4 py-6 max-w-2xl mx-auto">
        <div className="bg-white rounded-lg shadow-sm p-6 text-center space-y-6">
          <div className="bg-blue-100 w-20 h-20 rounded-full flex items-center justify-center mx-auto">
            <MessageCircle className="w-10 h-10 text-blue-600" />
          </div>

          <div>
            <h2 className="text-2xl font-bold text-gray-900 mb-2">We're Here to Help</h2>
            <p className="text-gray-600">
              Have questions or need assistance? We'd love to hear from you.
            </p>
          </div>

          <div className="bg-gray-50 rounded-lg p-6 space-y-4">
            <div className="flex items-center justify-center gap-2 text-gray-700">
              <Mail className="w-5 h-5 text-blue-600" />
              <span className="text-lg font-semibold">Email Us</span>
            </div>
            <a
              href="mailto:Admin@smartreadgo.com"
              className="text-xl font-bold text-blue-600 hover:text-blue-700 block"
            >
              Admin@smartreadgo.com
            </a>
          </div>

          <div className="bg-green-50 rounded-lg p-6 space-y-4">
            <div className="flex items-center justify-center gap-2 text-gray-700">
              <MessageCircle className="w-5 h-5 text-green-600" />
              <span className="text-lg font-semibold">WhatsApp</span>
            </div>
            <a
              href="https://wa.me/919004685736"
              className="text-xl font-bold text-green-600 hover:text-green-700 block"
            >
              +91 9004685736
            </a>
          </div>

          <div className="grid grid-cols-2 gap-3">
            <Button
              onClick={handleEmailClick}
              className="bg-blue-700 hover:bg-blue-800 text-white py-6 text-base"
            >
              <Mail className="w-5 h-5 mr-2" />
              Email
            </Button>
            
            <Button
              onClick={handleWhatsAppClick}
              className="bg-green-600 hover:bg-green-700 text-white py-6 text-base"
            >
              <MessageCircle className="w-5 h-5 mr-2" />
              WhatsApp
            </Button>
          </div>

          <div className="pt-4 space-y-2 text-sm text-gray-600">
            <p>📧 We typically respond within 24-48 hours</p>
            <p>🕒 Monday - Friday, 9:00 AM - 6:00 PM</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;